export class Qualiti {
  public listening = false
  public events: any[] = []
  public workflowName: string

  constructor() {
    this.forEachEvent(event => this.addDomEventListener(event))
  }

  public listenToEvents(workflowName?: string): void {
    this.listening = true
    this.workflowName = workflowName || ""
  }

  public stopListening(): void {
    this.listening = false
    this.workflowName = ""
    this.events = []
  }

  public forEachEvent(action: (key: string) => void): void {
    Object.keys(window).forEach(key => {
      if (/^on/.test(key)) {
        if (
          key !== "onload"
          && key !== "onclick"
          && key !== "onfocus"
          && key !== "onblur"
          && key !== "oninput"
          && key !== "ondblclick"
        ) { return }

        action(key)
      }
    })
  }

  public addDomEventListener(key: string): void {
    const eventName = key.slice(2)
    window.addEventListener(eventName, event => {
      if (!this.listening) { return }

      // tslint:disable-next-line: deprecation
      const element = (event.srcElement || event.target) as HTMLElement
      const paths = this.getPaths(element)
      const domEvent: any = {
        workflowName: this.workflowName,
        timestamp: new Date().toISOString(),
        type: "DOM",
        event: eventName,
        url: window.location.href,
        element: element instanceof Window
          ? null
          : {
            id: element.id,
            css: {
              structural: paths.structural,
              classesWithTags: paths.classesWithTags
            },
            xpath: paths.xpath,
          },
      }

      if (element && (element.tagName || "").toLowerCase() === "input") {
        const input = element as HTMLInputElement
        domEvent.input = {
          value: input.value,
          name: input.name,
          placeholder: input.placeholder,
          type: input.type,
        }
      }

      // TODO: Send domEvent object to server
      this.events.push(domEvent)
    })
  }

  public getPaths(element: HTMLElement): {
    structural: string[],
    classesWithTags: string[],
    xpath?: string[],
  } {
    let elementPath = ""
    const structuralPath = []
    const xpath = []
    do {
      let nthChild = ""
      let xpathChild = ""
      if (element.parentElement
          && element.parentElement.children
          && element.parentElement.children.length > 1) {
        const childIndex = this.getElementIndex(element)
        if (childIndex !== -1) {
          nthChild = `:nth-child(${childIndex + 1})`
          xpathChild = `[${childIndex + 1}]`
        }
      } else {
        nthChild = ":first-child"
        xpathChild = "[1]"
      }

      const classes = element && element.className
        ? `.${(element.className).toString().trim().split(" ").join(".")}`
        : ""

      const tag = element.tagName
      if (tag !== "HTML") {
        elementPath = `${tag}${element.id ? `#${element.id}` : classes}${nthChild} > ${elementPath}`
        elementPath = elementPath.endsWith(".") ? elementPath.slice(0, elementPath.length - 1) : elementPath
        xpath.push(`/${tag}${xpathChild}`)
        structuralPath.push(nthChild)

      }

      element = element.parentElement
    } while (element && (element.parentElement || element.parentNode))

    elementPath = elementPath.endsWith(" > ") ? elementPath.slice(0, elementPath.length - 3) : elementPath
    elementPath = elementPath.replace("..", ".")
    return {
      classesWithTags: elementPath.split(" > "),
      structural: structuralPath,
      xpath,
    }
  }

  public getElementIndex(element: HTMLElement): number {
    for (let i = 0; i < element.parentElement.children.length; i++) {
      if (element.parentElement.children.item(i) === element) {
        return i
      }
    }

    return -1
  }
}
